import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';

import LoginFormContainer from 'src/app/containers/Login/LoginFormContainer';
import LayoutOffersCount from 'src/app/components/Layout/LayoutOffersCount';
import { feedbackMessageShow } from 'src/app/redux/actions/feedbackMessage';
import alerts from 'src/app/alerts.json';
import background from 'src/assets/images/background-login.jpg';
import styles from 'src/app/containers/Login/LoginContainer.scss';


class LoginContainer extends React.Component {
  componentDidMount() {
    const { dispatch } = this.props;

    if (window.location.href.includes('facebook_access_denied')) {
      dispatch(feedbackMessageShow(alerts.loginFailed));
    }
  }

  render() {
    const { location } = this.props;

    return (
      <LayoutOffersCount background={ background }>
        <LoginFormContainer customClass={ styles.form }/>

        <h4 styleName="registration">
          Nie masz konta?{' '}
          <Link to={ { pathname: '/zaloz-konto', search: location.search } }
             styleName="registration__text-anchor"
             data-test="anchor-registration"
             title="Zarejestruj się"
          >
            Zarejestruj się
          </Link>
        </h4>

        <p styleName="for-business">
          Jesteś pracodawcą? Zaloguj się
          do <a href="https://dlafirm.pracuj.pl/sklep/?prlc=b2c_logowanie_pracuj&prnm=sekcja_b2c"
                title="Przejdź do Pracuj.pl dla Firm" styleName="for-business__link">
          Pracuj.pl dla Firm <span styleName="for-business__icon">launch</span>
          </a>
        </p>
      </LayoutOffersCount>
    );
  };
}

LoginContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired
  }).isRequired
};


export default connect()(withRouter(LoginContainer));
